export default () => {
  const summary = document.querySelector('.summary');
  const headings = document.querySelectorAll('#main_title, .article-content h2[id]');

  if (!summary || headings.length === 0) return;

  const summaryLinks = summary.querySelectorAll('.summary__list__item__link');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };

  const handleIntersect = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const visibleHeadingId = entry.target.id;

        summaryLinks.forEach((link) => {
          link.parentElement?.classList.remove('--is-active');
        });

        const activeLink = document.querySelector(`.summary__list__item__link[href="#${visibleHeadingId}"]`);
        if (activeLink) {
          activeLink.parentElement?.classList.add('--is-active');
        }
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersect, options);

  headings.forEach((heading) => {
    observer.observe(heading);
  });
};
